import React, { useState } from 'react';
import { WaitlistForm } from '../components/WaitlistForm';
import { WaitlistStats } from '../components/WaitlistStats';
import { useWaitlistCount } from '../hooks/useWaitlistCount';
import { CheckCircle2 } from 'lucide-react';
import { FadeIn } from '../components/animations/FadeIn';

function Waitlist() {
  const [submitted, setSubmitted] = useState(false);
  const { count, name: currentTier, spots: remainingSpots } = useWaitlistCount();
  const goalSignups = 2000;
  const progress = (count / goalSignups) * 100;

  return (
    <div className="min-h-screen bg-gray-50">
      <section className="max-w-3xl mx-auto px-4 py-12 md:py-16">
        {!submitted ? (
          <FadeIn>
            <div className="bg-white p-8 rounded-2xl shadow-lg border border-blue-100">
              <h1 className="text-3xl md:text-4xl font-bold mb-6 text-gray-900 text-center">
                Gå med i väntelistan
              </h1>
              <p className="text-lg text-gray-600 mb-8 text-center">
                Var bland de första att få tillgång till Utlysningslabbet och få exklusiva fördelar som tidig användare.
              </p>
              <WaitlistStats className="mb-8" />
              <div className="bg-blue-50 border border-blue-100 rounded-xl p-6 mb-8">
                <h3 className="text-xl font-bold text-gray-900 mb-2">
                  Som {currentTier} får du:
                </h3>
                <ul className="space-y-2">
                  {currentTier === 'Grundare' && (
                    <>
                      <li className="flex items-center gap-2 text-gray-700">
                        <CheckCircle2 className="text-blue-500 shrink-0" size={20} />
                        <span>3 månader gratis användning</span>
                      </li>
                      <li className="flex items-center gap-2 text-gray-700">
                        <CheckCircle2 className="text-blue-500 shrink-0" size={20} />
                        <span>Livstids VIP-support</span>
                      </li>
                      <li className="flex items-center gap-2 text-gray-700">
                        <CheckCircle2 className="text-blue-500 shrink-0" size={20} />
                        <span>Tidig åtkomst till nya funktioner</span>
                      </li>
                    </>
                  )}
                  {currentTier === 'Pionjär' && (
                    <>
                      <li className="flex items-center gap-2 text-gray-700">
                        <CheckCircle2 className="text-blue-500 shrink-0" size={20} />
                        <span>2 månader gratis användning</span>
                      </li>
                      <li className="flex items-center gap-2 text-gray-700">
                        <CheckCircle2 className="text-blue-500 shrink-0" size={20} />
                        <span>Prioriterad support</span>
                      </li>
                      <li className="flex items-center gap-2 text-gray-700">
                        <CheckCircle2 className="text-blue-500 shrink-0" size={20} />
                        <span>Tidig åtkomst till nya funktioner</span>
                      </li>
                    </>
                  )}
                  {currentTier === 'Tidig användare' && (
                    <>
                      <li className="flex items-center gap-2 text-gray-700">
                        <CheckCircle2 className="text-blue-500 shrink-0" size={20} />
                        <span>1 månad gratis användning</span>
                      </li>
                      <li className="flex items-center gap-2 text-gray-700">
                        <CheckCircle2 className="text-blue-500 shrink-0" size={20} />
                        <span>Tidig åtkomst till nya funktioner</span>
                      </li>
                    </>
                  )}
                </ul>
                <p className="text-sm text-gray-500 mt-4">
                  Endast {remainingSpots} platser kvar i denna nivå
                </p>
              </div>
              <WaitlistForm onSuccess={() => setSubmitted(true)} />
            </div>
          </FadeIn>
        ) : (
          <FadeIn>
            <div className="bg-green-50 p-8 rounded-2xl border border-green-100 shadow-lg text-center">
              <div className="flex items-center justify-center gap-3 mb-2">
                <CheckCircle2 className="text-green-500" size={28} />
                <p className="text-gray-900 font-semibold text-xl">
                  Grattis! Du är nu registrerad som {currentTier}
                </p>
              </div>
              <p className="text-gray-600 text-lg">
                Vi håller dig uppdaterad om projektets utveckling.
              </p>
            </div>
          </FadeIn>
        )}
      </section>
    </div>
  );
}

export default Waitlist;